import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import PageContainer from 'components/PageContainer';
import FieldRow from 'components/FormElements/FieldRow';
import { LINKED_PORTALS } from 'adminConstants/routes';
import PageContent from 'components/PageContent';
import RecordView from 'components/RecordView';
import ButtonGroup from 'components/ButtonGroup';
import trpcApi from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { FirmSelector } from 'components/FirmSelector';
import { Realm } from 'further-types/global';
import { AppSimpleSelect } from 'components/FormElements';

const breadcrumbs = [
  { label: 'Dashboard', link: '/' },
  { label: 'Linked Portals', isActive: true },
];

const AddNewLinkedPortals: React.FC = () => {
  const history = useHistory();
  const [copyFrom, setCopyFrom] = useState<Realm>(Realm.Eis);
  const [eisFirmId, setEisFirmId] = useState('');
  const [lpFirmId, setLpFirmId] = useState('');

  const createLinkedPortals =
    trpcApi.linkedPortals.createLinkedPortals.useMutation(
      useHandleTrpcMutation()({
        successMessage: 'Linked portal created successfully.',
        onSuccess: () => {
          history.push(LINKED_PORTALS);
        },
      }),
    );

  const onSubmit = () => {
    createLinkedPortals.mutate({ eisFirmId, lpFirmId, copyFrom });
  };

  return (
    <PageContainer heading="Add New Linked Portals" breadcrumbs={breadcrumbs}>
      <PageContent>
        <RecordView>
          <FieldRow title="EIS Firm">
            <FirmSelector
              firmId={eisFirmId}
              onChange={(firmId) => {
                setEisFirmId(firmId);
              }}
              firmRealmsToShow={Realm.Eis}
            />
          </FieldRow>

          <FieldRow title="LP Firm">
            <FirmSelector
              firmId={lpFirmId}
              onChange={(firmId) => {
                setLpFirmId(firmId);
              }}
              firmRealmsToShow={Realm.Lp}
            />
          </FieldRow>

          <FieldRow
            title="Copy from"
            informationText="When this link is created, some config will be shared straight away (the domain, firm name, logos, some colours etc). Choose whether to copy these existing settings from the EIS firm or the LP firm."
          >
            <AppSimpleSelect
              sx={{ width: '100px' }}
              options={[
                { value: Realm.Eis, label: Realm.Eis },
                { value: Realm.Lp, label: Realm.Lp },
              ]}
              value={copyFrom}
              onChange={(e) => {
                const value = e.target.value as Realm;
                setCopyFrom(value);
              }}
            />
          </FieldRow>

          <ButtonGroup>
            <Button variant="contained" color="primary" onClick={onSubmit}>
              Save
            </Button>
            <Link to={LINKED_PORTALS}>
              <Button variant="contained">Cancel</Button>
            </Link>
          </ButtonGroup>
        </RecordView>
      </PageContent>
    </PageContainer>
  );
};

export default AddNewLinkedPortals;
